import { CssBaseline, ThemeProvider } from "@mui/material";
import { useNavigate, useRoutes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ThemeSettings } from "./theme/Theme";
import RTL from "./layouts/full/shared/customizer/RTL";
import ScrollToTop from "./components/shared/ScrollToTop";
import Router from "./routes/Router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingModal from "./components/loading/loading";
import {
  Checkuser,
  dataLocalStorage,
  getLocalStorage,
} from "./helper/publicFunction";
import { useEffect } from "react";
import CommonAlertComponent from "./components/alert/CommonAlert";
import "./app.css";
import { useJsApiLoader } from "@react-google-maps/api";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setupAxiosInterceptors } from "./common/axiosSetup";
import { SocketProvider } from "./helper/SocketProvider";
import {
  useWaitingOrder,
  WaitingOrderProvider,
} from "./helper/WaitingOrderContext";
import Loading from "./components/Loading";

function App() {
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setupAxiosInterceptors(dispatch);
  }, [dispatch]);

  const queryClient = new QueryClient();

  useEffect(() => {
    Checkuser({ dispatch, navigate });

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
  const handleBeforeUnload = (event) => {
    if (getLocalStorage(dataLocalStorage.loading_check_user) ?? true) {
      event.preventDefault();
      event.returnValue =
        "You have an ongoing API request. Are you sure you want to leave?";
    }
  };
  const libraries = ["geometry", "drawing", "places"];
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyDEbtGkgxd-WON0m2-n86fHpq7TG2YnhG4",
    libraries: libraries,
  });

  useEffect(() => {
    if (isLoaded) {
      localStorage.setItem("isGoogleMapsLoaded", JSON.stringify(isLoaded));
    }
  }, [isLoaded]);

  const { isWaitingOrder, updateIsWaitingOrder, updateInProgressOrderId } =
    useWaitingOrder();

  useEffect(() => {
    localStorage.setItem("isWaitingOrder", "false");
    localStorage.setItem("inProgress_orderId", null);
    updateIsWaitingOrder(false);
    updateInProgressOrderId(null);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <SocketProvider>
          <RTL direction={customizer.activeDir}>
            <CssBaseline />
            <ScrollToTop>
              <CommonAlertComponent />
              {isWaitingOrder === "true" || isWaitingOrder === true ? (
                <Loading />
              ) : (
                routing
              )}
            </ScrollToTop>
            <ReactQueryDevtools initialIsOpen={false} position="left" />
            <ToastContainer />
            <LoadingModal />
          </RTL>
        </SocketProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
